export default __webpack_public_path__ + "static/media/article.3cf07699.jpeg";